import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { LOGIN } from '../../routes/routes';
import { ErrorToast, SuccessToast } from '../../components';

interface ResetPasswordType {
  code: string;
  password: string;
  result: any;
  history: any;
}

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (
    { code, password, result, history }: ResetPasswordType,
    { rejectWithValue }
  ) => {
    const {
      lot_number: lotNumber,
      captcha_output: captchaOutput,
      pass_token: passToken,
      gen_time: genTime
    } = result;

    try {
      const { data } = await axios.put(`/authorization/password/reset`, {
        code,
        password,
        lotNumber,
        captchaOutput,
        passToken,
        genTime
      });

      history.push(LOGIN);

      SuccessToast(data.message);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);

interface SendResetPasswordEmailType {
  id: string;
  type: number;
  result: any;
}

export const sendResetPasswordEmail = createAsyncThunk(
  'auth/sendResetPasswordEmail',
  async (
    { id, type, result }: SendResetPasswordEmailType,
    { rejectWithValue }
  ) => {
    try {
      const {
        lot_number: lotNumber,
        captcha_output: captchaOutput,
        pass_token: passToken,
        gen_time: genTime
      } = result;

      const { data } = await axios.post(
        `/authorization/forgotten-password/send`,
        type === 1
          ? {
              email: id,
              lotNumber,
              captchaOutput,
              passToken,
              genTime
            }
          : type === 2
          ? {
              userId: Number(id),
              lotNumber,
              captchaOutput,
              passToken,
              genTime
            }
          : {
              username: id,
              lotNumber,
              captchaOutput,
              passToken,
              genTime
            }
      );

      SuccessToast(data.message);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
